import { render } from "./reservationsView.vue?vue&type=template&id=6cb6cb15"
import script from "./reservationsView.vue?vue&type=script&lang=js"
export * from "./reservationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__